// extracted by mini-css-extract-plugin
export var bottom = "_87baf";
export var button = "_5bb7b";
export var icon = "_20f3a";
export var left = "ceca9";
export var right = "_3ffc8";
export var top = "d7f44";